import { render, staticRenderFns } from "./AdminChatComponent.vue?vue&type=template&id=2f5be2a8&scoped=true&"
import script from "./AdminChatComponent.vue?vue&type=script&lang=js&"
export * from "./AdminChatComponent.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./AdminChatComponent.vue?vue&type=style&index=1&id=2f5be2a8&prod&lang=css&"
import style2 from "./AdminChatComponent.vue?vue&type=style&index=2&id=2f5be2a8&prod&lang=css&"
import style3 from "./AdminChatComponent.vue?vue&type=style&index=3&id=2f5be2a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5be2a8",
  null
  
)

export default component.exports